import moment from "moment-timezone";

const TZ_REGEX = /( .+\/)/gi;

function transformTZName(z) {
  return z.replace(TZ_REGEX, " ");
}

export function getDefaultTZ() {
  let defaultTZ = moment.tz(moment.tz.guess()).format("Z") + " " + moment.tz.guess();
  return transformTZName(defaultTZ);
}

export function getTZ(timeZoneId) {
  let tz = moment.tz(timeZoneId).format("Z") + " " + timeZoneId;
  return transformTZName(tz);
}

export function getTimeZones() {
  let timeZones = [];
  let names = Object.keys(moment.tz._zones)
    .map(function (k) {
      if (typeof moment.tz._zones[k].split === "function") {
        return moment.tz._zones[k].split("|")[0];
      } else if (moment.tz._zones[k].name) {
        return moment.tz._zones[k].name;
      }
      return "";
    })
    .filter(function (z) {
      return z && z.indexOf("/") >= 0 && z.indexOf("Etc/") === -1;
    });
  for (var i = 0; i < names.length; i++) {
    let tzName = moment.tz(names[i]).format("Z") + " " + names[i];
    timeZones.push(transformTZName(tzName));
  }

  return timeZones.sort(function (a, b) {
    if (a === b) {
      return 0;
    }
    if (a.charAt(0) === b.charAt(0)) {
      var sign = a.charAt(0);
      var hoursA = parseInt(a.substring(0, 3), 10);
      var hoursB = parseInt(b.substring(0, 3), 10);
      if (hoursA > hoursB) {
        return 1;
      } else if (hoursA < hoursB) {
        return -1;
      } else {
        var minsA = parseInt(a.substring(4, 6), 10);
        var minsB = parseInt(b.substring(4, 6), 10);
        if (minsA > minsB) {
          return sign === "+" ? 1 : -1;
        } else if (minsA < minsB) {
          return sign === "+" ? -1 : 1;
        } else {
          var nameA = a.substring(7);
          var nameB = b.substring(7);
          if (nameA > nameB) {
            return 1;
          } else if (nameA < nameB) {
            return -1;
          } else {
            return 0;
          }
        }
      }
    } else {
      return a < b ? 1 : -1;
    }
  });
}

export const getTimezoneIdByPartialName = () => {
  const name = getDefaultTZ().split(" ")[1];
  return moment.tz.names().find(tzName => tzName.indexOf(name) > -1);
};

export const getTimezoneIdFromName = timezoneName => {
  const name = timezoneName.split(" ")[1];
  return moment.tz.names().find(tzName => tzName.indexOf(name) > -1);
};
